import { app } from '../../../../../../app';
import { Controller } from './directory-manage-sync-and-prov-scim.controller';

app.component('companyDirectoryIntegrationManageSyncAndProvScim', {
    bindings: {
        directoryStatus: '<',
        companyId: '<',
        directory: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-sync-and-prov-scim.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/sync-and-prov/directory-manage-sync-and-prov-scim.component.js